import { find } from 'lodash';
// import queryString from 'query-string';

import isNormalInteger from '../Util/isNormalInteger';

const QUERY_KEY_START = 'start';

/**
 * DDDのvalue object
 * query stringのstart用
 */
class StartValue {
  constructor(parsed) {
    this.start = this.init(parsed);
  }

  /**
   * startを初期化する
   */
  init(parsed) {
    // 取得
    const start = find(parsed, (v,key) => {
      return key === QUERY_KEY_START;
    });

    // 検証
    if (!isNormalInteger(start)) {
      return false;
    }

    const intStart = parseFloat(start, 10);
    if (intStart <= 0) {
      return false
    }
    return intStart;
  }

  // ***************************
  // getter / setter
  // ***************************
  get start() {
    return this._start;
  }
  set start(val) {
    return this._start = val;
  }
}

export default StartValue;
